import React from 'react'

import './_split-layout.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    left: React.ReactNode
    right: React.ReactNode
    verticalAlignment?: 'baseline' | 'center' | 'start' | 'end'
    wraps?: boolean
    growLeft?: boolean
  }
>

const SplitLayout = ({
  className,
  left,
  right,
  verticalAlignment = 'baseline',
  wraps = false,
  growLeft = false,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn(
      'SplitLayout',
      {[`verticalAlignment-${verticalAlignment}`]: true, wraps, growLeft},
      className
    )}
  >
    <div className="SplitLayout__left">{left}</div>
    <div className="SplitLayout__right">{right}</div>
  </div>
)

export default SplitLayout
